<template>
    <div v-show="CHANNEL_YXL_STATEMENT || showTip" class="support">
      <p v-if="isHwrl">本服务由中华万年历联合壹心理提供</p>
      <p v-else>壹心理©提供内容及技术支持</p>
    </div>
</template>

<script>
import {
  mapGetters
} from 'vuex';

export default {
  name: 'yxlCopyright',
  computed: mapGetters([
    'CHANNEL_YXL_STATEMENT'
  ]),
  props:{
    showTip:{
      type: Boolean,
      default: false
    }
  }

}
</script>

<style lang="scss" scoped>
    @import '../../scss/function';

.support {
  padding-top: topx(30rem)!important;;
  padding-bottom: topx(30rem)!important;;
  font-size: 12px !important;;
  // color: #BFBFCA!important;
  line-height: 1.25 !important;;
  text-align: center;
  color: #BFBFCA;
}
</style>



// WEBPACK FOOTER //
// src/components/common/yxlCopyright.vue